import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "vue-material-design-icons/styles.css";
import SlitherSlider from "slither-slider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import store from "./store";
import VModal from "vue-js-modal";
import VueGtag from "vue-gtag";
import VueToast from "vue-toast-notification";
Vue.use(SlitherSlider);
Vue.use(VModal);
import "vue-toast-notification/dist/theme-default.css";
Vue.use(VueToast, {
  position: "top-right"
});
Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-HJGWMTD4ZC",
      params: {
        send_page_view: false
      }
    }
  },
  router
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
